export class HistoryHelper {
  static goBack = (event: any, history: any, path: string) => {
    event.preventDefault();
    history.push(path);
  };
}
